export const ApiBaseUrl2 = "https://localhost:44318/";
export const ApiBaseUrl = "https://api.edf.ly/";
